import { render, staticRenderFns } from "./MyQuotes.vue?vue&type=template&id=4748f944&"
import script from "./MyQuotes.vue?vue&type=script&lang=js&"
export * from "./MyQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports